// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { MeasureTool } from '../../bygning/ruler';
import styles from './Ground.module.css';

export interface MeasureButtonsProps {
  /** The tool on now. */
  tool: MeasureTool;
  /** Turn a tool on (null: off). */
  onTool: (tool: MeasureTool) => void;
}

/**
 * Mål afstand and Mål areal on the Ground's toolbar, beside Vælg punkt
 * (frontend-aa2): pressing the one that is on turns it off.
 */
export function MeasureButtons({ tool, onTool }: MeasureButtonsProps) {
  return (
    <>
      <button
        type="button"
        className={`${styles.tool}${tool === 'distance' ? ` ${styles.toolOn}` : ''}`}
        aria-pressed={tool === 'distance'}
        onClick={() => onTool(tool === 'distance' ? null : 'distance')}
        title={
          tool === 'distance'
            ? 'Afslut måling (Esc)'
            : 'Mål en afstand — klik punkter i modellen; den snapper til punkter, hjørner, vægge og åbninger (hold Alt for at slå det fra)'
        }
      >
        <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" className={styles.toolIcon}>
          <path d="M1.5 11.5 11.5 1.5l3 3-10 10z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
          <path d="M4.5 8.5 6 10M7 6l1.5 1.5M9.5 3.5 11 5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
        </svg>
        Mål afstand
      </button>
      <button
        type="button"
        className={`${styles.tool}${tool === 'area' ? ` ${styles.toolOn}` : ''}`}
        aria-pressed={tool === 'area'}
        onClick={() => onTool(tool === 'area' ? null : 'area')}
        title={tool === 'area' ? 'Afslut måling (Esc)' : 'Mål et areal — klik hjørnerne, dobbeltklik eller Enter for at lukke flagen'}
      >
        <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" className={styles.toolIcon}>
          <path d="M2.5 4.5 9 2l4.5 5-3 6.5-7.5-2z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
          <circle cx="2.5" cy="4.5" r="1.25" fill="currentColor" />
          <circle cx="9" cy="2" r="1.25" fill="currentColor" />
          <circle cx="13.5" cy="7" r="1.25" fill="currentColor" />
          <circle cx="10.5" cy="13.5" r="1.25" fill="currentColor" />
          <circle cx="3" cy="11.5" r="1.25" fill="currentColor" />
        </svg>
        Mål areal
      </button>
    </>
  );
}
